import { createContext, useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { isAuthenticated, isLoading, user, loginWithRedirect, logout, getAccessTokenSilently } = useAuth0();

  const value = useMemo(() => ({
    isLoggedIn: isAuthenticated,
    isLoading,
    user,
    login: () => loginWithRedirect(),
    logout: () => logout({ logoutParams: { returnTo: window.location.origin } }),
    getAccessTokenSilently
  }), [isAuthenticated, isLoading, user, loginWithRedirect, logout, getAccessTokenSilently]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
